import React, { Component } from 'react'

import {api} from '../../common/app'

export class WxAuth extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    componentDidMount() {
      if(process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === "development" ){
          this.isAuth();
      }
    }

    isAuth(){
        api.getWxAuth(window.location.href).then(res=>{
            if (res.code === 200) {
                window.location.href = res.result.url;
            }
        },err=>{
            console.log(err);
        })
    }
    render() {
      return (
        <div style={{display:'none'}}>

        </div>
       )
   }
}
export default WxAuth
